import MyTimeOffsPageContent from './MyTimeOffsPageContent.container';

export default MyTimeOffsPageContent;
